/** Generate callback of .sort() to keep a specific value at the end. */
const sortWithFixedLast = (key, lastValue) => (a, b) => 
    (a[key] === lastValue || b[key] === lastValue)
        ? 1
        : a[key].localeCompare(b[key]);

export default sortWithFixedLast;
